import { queryValueToArrayOfIds } from "~/common/helpers/query-value-to-array-of-ids";

export const useQueryValueIdMapping = (queryName: string) => {
	const router = useRouter();
	const route = useRoute();

	const ids = computed(() => queryValueToArrayOfIds(route.query[queryName]));

	const switchQueryId = (id: number) => {
		const selectedIds = [...ids.value];

		const selectedIdIndex = selectedIds.indexOf(id);
		if (selectedIdIndex === -1) {
			selectedIds.push(id);
		} else {
			selectedIds.splice(selectedIdIndex, 1);
		}

		const query = {
			...route.query,
			[queryName]: selectedIds
		};
		router.push({
			query
		});
	};

	return {
		ids,
		switchQueryId
	};
};
